import { Link } from "@quintype/components";
import "./menus-chip.m.css";
import React from "react";
import Speaker from "../other-icons/Speaker";

const MenusChip = ({ menus = [] }) => {
  // Helper to extract path from URL
  const extractPath = (url) => {
    if (!url) return '';
    try {
      if (url.startsWith('http://') || url.startsWith('https://')) {
        const urlObj = new URL(url);
        return urlObj.pathname;
      }
      return url;
    } catch (e) {
      return url;
    }
  };

  // Store which secondary menu was clicked
  const handleSecondaryClick = (item) => {
    try {
      const urlPath = extractPath(item.completeUrl);
      const cleanUrl = urlPath.split('?')[0].split('#')[0];
      sessionStorage.setItem('clickedMenu', JSON.stringify({
        url: cleanUrl,
        menuId: item.id,
        type: 'secondary'
      }));
    } catch (e) {
      // Ignore storage errors
    }
  };

  return (
    <div styleName="menus-wrapper">
      <span styleName="speaker" aria-hidden="true">
        <Speaker />
      </span>

      <div styleName="chips" role="navigation" aria-label="Quick links">
        {menus.slice(0, 6).map((item, idx) => {
          const color = item.data?.color;

          return (
            <Link
              key={idx}
              href={item.completeUrl}
              styleName="chip"
              style={
                color && color !== "#FFFFFF"
                  ? {
                    backgroundColor: "var(--tall-poppy)",
                    color: "var(--white)"
                  }
                  : undefined
              }
              onMouseDown={() => handleSecondaryClick(item)}
            >
              {item.title}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MenusChip;
